import { createClient } from '@supabase/supabase-js';

// Replace with your own Supabase project URL and API key
const supabaseUrl = 'https://afvhcaqgrvotvgnhqupx.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFmdmhjYXFncnZvdHZnbmhxdXB4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxMDExNjEsImV4cCI6MjA1NzY3NzE2MX0.HqX7_ALkwbRR68SioVabHTTYsV4Xhrpb7e0zxG96tmM';
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
